import { resolveQueueBucket } from '@/features/workspace/utils/status-map'
import type { GlobalSearchResult } from '../hooks/use-global-search'

function appendQueueBucketParam(url: string, metadata?: Record<string, string | null>): string {
  const bucket = resolveQueueBucket(metadata?.status, metadata?.coding_mode)
  if (!bucket) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}bucket=${encodeURIComponent(bucket)}`
}

// ── Route mapping ──
//
// Every category navigates somewhere now. Codes go to their KB subroute with
// the code prefilled in the search box; charts (encounters) open in unified
// review; provider / facility drill through to the queue with entity
// filters plus a `bucket` param so the chart lands in the correct tab.

export function getResultRoute(result: GlobalSearchResult): string | null {
  // The flattened id is `${category}-${original_id}` — strip the prefix.
  const rawId = result.id.replace(/^[^-]+-/, '')
  const m = result.metadata ?? {}
  switch (result.category) {
    case 'icd':
      return `/kb/icd?q=${encodeURIComponent(result.title)}`
    case 'cpt':
      return `/kb/cpt?q=${encodeURIComponent(result.title)}`
    case 'hcpcs':
      return `/kb/hcpcs?q=${encodeURIComponent(result.title)}`
    case 'modifier':
      return `/kb/modifiers?q=${encodeURIComponent(result.title)}`
    case 'encounter':
      return `/workspace/queue/${rawId}`
    case 'provider': {
      const base = `/workspace/queue?provider_id=${encodeURIComponent(m.provider_id ?? rawId)}`
      return appendQueueBucketParam(base, m)
    }
    case 'facility': {
      const base = `/workspace/queue?facility_id=${encodeURIComponent(m.facility_id ?? rawId)}`
      return appendQueueBucketParam(base, m)
    }
    case 'specialty': {
      // Specialty results carry the kb code (e.g. "family_medicine") which
      // is the same value the queue's ?specialty= filter expects.
      const code = m.specialty_code ?? rawId
      return `/workspace/queue?specialty=${encodeURIComponent(code)}`
    }
    default:
      return null
  }
}
